<template>
  <v-dialog :model-value="modelValue" max-width="650" min-width="300">
    <v-card class="d-flex flex-column px-4 pb-2">
      <v-sheet class="text-h6 py-2 d-flex align-center">
        Διαχείριση αντικατάστασης λέξεων
        <v-spacer />
        <v-btn
          variant="plain"
          size="x-small"
          icon="mdi-close"
          @click="$emit('update:modelValue', false)"
        />
      </v-sheet>
      <v-sheet rounded class="border mb-4" style="max-height: 70vh; overflow: auto">
        <v-table class="word-replace-table" hover hide-default-footer density="compact">
          <thead class="bg-grey-lighten-3">
            <tr>
              <th class="pl-4 pr-4 text-truncate text-center border-e" style="min-width: 120px">
                Λέξη εισόδου
              </th>
              <th class="pr-4 text-truncate text-center border-e" style="min-width: 150px">
                Λέξη αντικατάστασης
              </th>
            </tr>
          </thead>
          <tbody style="max-height: calc(70vh - 48px); overflow-y: auto">
            <tr
              v-for="replacement in wordReplacements"
              :key="replacement.inputWord"
              :class="{
                'selected-row':
                  selectedReplacement && selectedReplacement.inputWord === replacement.inputWord,
                'hoverable-row': true
              }"
              @click="selectedReplacement = replacement"
            >
              <td class="pl-4 pr-4 border-e">{{ replacement.inputWord }}</td>
              <td class="pr-4 border-e">{{ replacement.replacementWord }}</td>
            </tr>
            <tr v-if="wordReplacements.length === 0">
              <td colspan="2" class="text-center">Δεν υπάρχουν καταχωρήσεις</td>
            </tr>
          </tbody>
        </v-table>
      </v-sheet>
      <div class="d-flex justify-end">
        <v-btn
          size="small"
          elevation="1"
          color="grey-lighten-2"
          height="24"
          class="ml-3 mr-3 px-1 text-capitalize"
          @click="addWordDialog = true"
        >
          Προσθήκη ζεύγους
        </v-btn>
        <v-btn
          size="small"
          elevation="1"
          color="grey-lighten-2"
          height="24"
          class="ml-3 mr-3 px-1 text-capitalize"
          :disabled="!selectedReplacement"
          :class="{ 'opacity-40': !selectedReplacement }"
          @click="removeSelectedReplacement"
        >
          Διαγραφή ζεύγους
        </v-btn>
        <v-btn
          size="small"
          elevation="1"
          color="grey-lighten-2"
          height="24"
          class="ml-3 mr-3 px-1 text-capitalize"
          @click="$emit('update:modelValue', false)"
        >
          OK
        </v-btn>

        <v-btn
          size="small"
          elevation="1"
          color="grey-lighten-2"
          height="24"
          class="ml-3 mr-3 px-1 text-capitalize"
          @click="$emit('update:modelValue', false)"
        >
          Άκυρο
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

  <WordReplaceAddDialog v-model="addWordDialog" @resetWords="resetWords" />
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getWordReplacements, removeWordReplacement } from '@/utils/wordReplacements.interface'
import WordReplaceAddDialog from './WordReplaceAddDialog.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  }
})

defineEmits(['update:modelValue', 'openAddWord'])

const wordReplacements = ref([])
const selectedReplacement = ref(null)
const addWordDialog = ref(false)

onMounted(() => {
  wordReplacements.value = getWordReplacements()
})

const removeSelectedReplacement = () => {
  if (selectedReplacement.value) {
    removeWordReplacement(selectedReplacement.value.inputWord)
    wordReplacements.value = getWordReplacements()
    selectedReplacement.value = null
  }
}

const resetWords = () => {
  wordReplacements.value = getWordReplacements()
}
</script>

<style scoped>
.selected-row {
  outline: 2px solid #1976d2;
  outline-offset: -2px;
  background-color: #e3f2fd !important;
}
.hoverable-row:hover {
  outline: 2px solid #90caf9;
  outline-offset: -2px;
  background-color: #f5fafd !important;
  cursor: pointer;
}
</style>
